import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgMasterCard(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "master-card_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 24,
      height: 24
    }, {
      children: _jsx("path", {
        fill: "#C4C4C4",
        d: "M0 0h24v24H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#master-card_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M14.678 7.19H9.323v8.747h5.355V7.19z",
        fill: "#FF5F00"
      }, void 0), _jsx("path", {
        d: "M9.875 11.565a5.553 5.553 0 012.124-4.373 5.563 5.563 0 100 8.747 5.551 5.551 0 01-2.124-4.374z",
        fill: "#EB001B"
      }, void 0), _jsx("path", {
        d: "M20.468 15.011v-.18h.077v-.036h-.184v.037h.073v.179h.034zm.357 0v-.216h-.056l-.065.154-.065-.154h-.055v.216h.04v-.164l.06.14h.042l.06-.14v.164h.038zM21 11.564a5.563 5.563 0 01-9 4.372 5.561 5.561 0 000-8.746 5.562 5.562 0 019 4.372v.002z",
        fill: "#F79E1B"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgMasterCard;